import './cateringconnections/style';
import FormStructure from './cateringconnections/form_structure';

export default FormStructure;